import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=2b50b409&scoped=true"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveButton.vue?vue&type=style&index=0&id=2b50b409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50b409",
  null
  
)

export default component.exports